import { useQuery, useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import {
  templateLibraryService,
  TemplateLibraryFiltersResponse,
  TemplateLibraryListResponse,
  TemplateLibraryFilters,
} from '../services/templateLibrary.service';

export const TEMPLATE_LIBRARY_QUERY_KEYS = {
  all: ['template-library'] as const,
};

export const useTemplateLibraryFiltersQuery = (options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;

  return useQuery<TemplateLibraryFiltersResponse, Error>({
    queryKey: [...TEMPLATE_LIBRARY_QUERY_KEYS.all, 'filters'],
    queryFn: () => templateLibraryService.getTemplateLibraryFilters(),
    enabled,
  });
};

export const useTemplateLibraryListQuery = (filters: TemplateLibraryFilters = {}) => {
  return useInfiniteQuery<TemplateLibraryListResponse, Error>({
    queryKey: [
      ...TEMPLATE_LIBRARY_QUERY_KEYS.all,
      'list',
      filters.categoryKey ?? '',
      filters.industryKeys?.join(',') ?? '',
      filters.subcategoryKeys?.join(',') ?? '',
      filters.search ?? '',
    ],
    queryFn: ({ pageParam }) =>
      templateLibraryService.getTemplateLibraryList({
        ...filters,
        page: pageParam as number,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.totalPages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    placeholderData: keepPreviousData,
  });
};
